/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Params } from './index';
import { Card } from '../../routes/home/partials/cards';
import RequestDemoModal from '../request-demo-modal';
import { BasicAlert } from '../alert/BasicAlert';
import { ProductCardGrid } from './ProductCard';

interface PriceInfoProps {
  priceInfoList: {
    productName: string;
    productSynopsis: string;
    productBenefits?: { html: string };
    priceHeading: string;
    productPrice?: string;
  };
  cards: Card[];
  isLoggedIn: boolean;
}

const PriceInfo = (props: PriceInfoProps) => {
  const { priceInfoList, cards, isLoggedIn } = props;
  const params = useParams<Params>()

  const [requestModalOpen, setRequestDemoModalOpen] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const toggleRequestDemoModal = () => setRequestDemoModalOpen(!requestModalOpen);

  return <div className='price-info-container border-bottom pb-5'>
    <BasicAlert className={'text-center success-alert-container'} type={'success'}>{submitMessage}</BasicAlert>
    <h1 className='mt-5'>{priceInfoList.productName}</h1>
    <h2>{priceInfoList.productSynopsis}</h2>
    <div className='d-flex justify-content-between mt-5 flex-column flex-md-row'>
      <ProductCardGrid isLoggedIn={isLoggedIn} cards={cards.filter(card => card.slug === params.slug)} toggleRequestDemoModal={toggleRequestDemoModal} />
      <div className='mt-4 mt-md-0'>
        <h2 className='strong mb-3'>{priceInfoList.priceHeading}</h2>
        {priceInfoList.productPrice && <h2 className='price py-1 px-3 strong'><span>{priceInfoList.productPrice}</span></h2>}
        <div
          className='mt-4 body'
          dangerouslySetInnerHTML={{ __html: priceInfoList.productBenefits?.html ?? '' }}
        />
      </div>
    </div>
    <RequestDemoModal
      isOpen={requestModalOpen}
      toggle={toggleRequestDemoModal}
      onSubmit={() => {
        setSubmitMessage('Message sent. We’ll be in touch shortly.');
        setTimeout(() => setSubmitMessage(''), 10000);
      }}
    />
  </div>
}

export default PriceInfo;
